// Attack surface signals derived from `client_enrichment.shodan` (exposed
// services scan) and the volume/diversity of `ct_subdomains`.
// Universal across profiles.

const HIGH_RISK_SHODAN_BANNERS = [
  // Database engines exposed to the public internet
  { pattern: /\b(mysql|postgresql|mongodb|redis|memcached|elastic)\b/i, label: 'database directly exposed', vector: 'unpatched_systems', weight: 0.20 },
  // Management interfaces
  { pattern: /\b(rdp|3389|vnc)\b/i, label: 'RDP/VNC exposed', vector: 'unpatched_systems', weight: 0.20 },
  { pattern: /\b(esxi|vsphere|vcenter)\b/i, label: 'VMware management interface exposed', vector: 'unpatched_systems', weight: 0.25 },
  // Edge appliances frequently exploited by ransomware groups
  { pattern: /\b(fortinet|fortigate|fortios)\b/i, label: 'Fortinet appliance', vector: 'unpatched_systems', weight: 0.10 },
  { pattern: /\b(cisco asa|anyconnect)\b/i, label: 'Cisco ASA / AnyConnect', vector: 'unpatched_systems', weight: 0.10 },
  { pattern: /\b(netscaler|citrix)\b/i, label: 'Citrix NetScaler', vector: 'unpatched_systems', weight: 0.10 },
  { pattern: /\b(ivanti|pulse secure)\b/i, label: 'Ivanti / Pulse Secure', vector: 'unpatched_systems', weight: 0.10 },
  // Industrial / OT
  { pattern: /\b(modbus|bacnet|knx|s7comm|dnp3|iec-104)\b/i, label: 'industrial / building automation protocol exposed', vector: 'ot_compromise', weight: 0.30 },
  // File transfer
  { pattern: /\b(moveit|goanywhere|cleo|accellion)\b/i, label: 'managed file transfer appliance', vector: 'supply_chain', weight: 0.20 }
]

export function detectAttackSurfaceSignals({ shodan = {}, ctSubdomains = [] } = {}) {
  const adj = { attackVectors: {}, threatActors: {} }
  const evidence = []
  const findings = []

  // Shodan-derived exposed services
  const services = shodan?.services || shodan?.detectedServices || []
  const banners = (Array.isArray(services) ? services : []).map(s =>
    typeof s === 'string' ? s : (s?.banner || s?.product || s?.service || '')
  ).filter(Boolean)

  for (const banner of banners) {
    for (const rule of HIGH_RISK_SHODAN_BANNERS) {
      if (rule.pattern.test(banner)) {
        adj.attackVectors[rule.vector] = (adj.attackVectors[rule.vector] || 0) + rule.weight
        findings.push(`${rule.label}: "${banner}"`)
      }
    }
  }

  // Subdomain volume — large external surface increases attacker reconnaissance value
  const subCount = Array.isArray(ctSubdomains) ? ctSubdomains.length : 0
  if (subCount >= 100) {
    adj.attackVectors.unpatched_systems = (adj.attackVectors.unpatched_systems || 0) + 0.10
    findings.push(`${subCount} subdomains discovered via certificate transparency — broad external attack surface`)
  } else if (subCount >= 30) {
    adj.attackVectors.unpatched_systems = (adj.attackVectors.unpatched_systems || 0) + 0.05
    findings.push(`${subCount} subdomains discovered — moderate external attack surface`)
  }

  if (findings.length > 0) {
    evidence.push(...findings.map(f => `Attack surface: ${f}`))
  }

  return { adjustments: adj, evidence, findings }
}
